import './Menu.scss'
import Logo from './logo/Logo'
import StatusCommand from './statusCommand/StatusCommand'
import SettingsCommand from './settingsCommand/SettingsCommand'
import CurrentIncidentCollectionTab from './currentIncidentCollectionTab/CurrentIncidentCollectionTab'
import User from './user/User'
import DomainSelector from './domainSelector/DomainSelector'
import IncidentCollectionRequestType from './../../common/types/IncidentCollectionRequestType'
import IIncidentOverview from './../../common/interfaces/incidentOverview/IIncidentOverview'
import IEntityIncident from '../../common/interfaces/entityIncident/IEntityIncident'

import IncidentDecisionMakerClueFilterSelector from './incidentDecisionMakerClueFilterSelector/IncidentDecisionMakerClueFilterSelector'
import IUserIncidentDecisionMakerClue from '../../common/interfaces/entityIncident/IUserIncidentDecisionMakerClue'
import ICustomer from '../../common/interfaces/customer/ICustomer'

type ComponentProps = {
  customerID:string
  domain:string
  incidentOverview:null|undefined|IIncidentOverview
  handleRefreshApplication: () => void
  handleSettingsMinimizeOverviewWhenRequestingCollectionChange: (value:boolean) => void
  settingsMinimizeOverviewWhenRequestingCollection: boolean
  handleSettingsShowUserGuideTopicChange: (value:boolean) => void
  handleDomainChangeRequest: (domain:string) => void
  handleIncidentDecisionMakerClueFilterChangeRequest: (incidentDecisionMakerClueFilter:null|undefined|string) => void
  handleIncidentCollectionChangeRequest: (request:IncidentCollectionRequestType) => void
  handleIncidentOverviewRequest: () => void
  incidentCollectionRequest?: IncidentCollectionRequestType
  incidentCollection?: IEntityIncident[]
  handleIncidentCollectionClose: () => void
  customer:ICustomer
  userIncidentDecisionMakerClues:IUserIncidentDecisionMakerClue[]
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
}

const Menu = (props:ComponentProps) => {

  return (
    <div id='menu' className={props.incidentCollection ? 'menu-no-default-dark' : 'menu-default-dark'} onClickCapture={() => props.handleActiveUserGuideTopicNameChangeRequest('menu')}>

      <div id='logo-wrapper' className='gap-to-next' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('menuLogo')}>
        <Logo 
          incidentCollectionRequest={props.incidentCollectionRequest} 
          handleIncidentOverviewRequest={props.handleIncidentOverviewRequest}
          handleIncidentCollectionChangeRequest={props.handleIncidentCollectionChangeRequest}
        />
      </div>

      <div id='status-command-wrapper' className='gap-to-next' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('menuScore')}>
        {
          props.incidentOverview?.status?.detailedAnalysis?.userIncidentScores && 
          <StatusCommand 
            incidentOverview={props.incidentOverview} 
            handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
          />
        }
      </div>

      <div id='settings-command-wrapper' className='gap-to-next' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('menuSettings')}>
        <SettingsCommand 
          handleSettingsMinimizeOverviewWhenRequestingCollectionChange={props.handleSettingsMinimizeOverviewWhenRequestingCollectionChange}
          settingsMinimizeOverviewWhenRequestingCollection={props.settingsMinimizeOverviewWhenRequestingCollection}
          handleSettingsShowUserGuideTopicChange={props.handleSettingsShowUserGuideTopicChange}
          handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
        />
      </div>

      <div id='domain-selector-wrapper' className='gap-to-next' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('menuDomainSelector')}>
        <DomainSelector 
          customer={props.customer}
          handleDomainChangeRequest={props.handleDomainChangeRequest}
        />
      </div>

      <div id='incident-decision-maker-clue-filter-selector-wrapper' className='gap-to-next' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('menuDecisionMakerFilterSelector')}>
        {
          props.userIncidentDecisionMakerClues?.length > 0 && 
          props.userIncidentDecisionMakerClues.find(incidentDecisionMakerClue => incidentDecisionMakerClue.isSecondary === true) &&
          <IncidentDecisionMakerClueFilterSelector 
            userIncidentDecisionMakerClues={props.userIncidentDecisionMakerClues}
            handleIncidentDecisionMakerClueFilterChangeRequest={props.handleIncidentDecisionMakerClueFilterChangeRequest}
          />    
        }
      </div>    

      <div id='current-incident-collection-tab-wrapper' className='gap-to-next' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('menuIncidentCollectionTab')}>
        {
          props.incidentCollectionRequest &&
          <CurrentIncidentCollectionTab 
            incidentCollectionRequest={props.incidentCollectionRequest} 
            incidentCollection={props.incidentCollection} 
            handleIncidentCollectionClose={props.handleIncidentCollectionClose}/>
        }
      </div>

      <div id='user-wrapper'  onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('menuUserLoginInformation')}>
        <User />
      </div>

    </div>
  )
}

export default Menu